import { render, staticRenderFns } from "./selectSizeGroup.vue?vue&type=template&id=47dff5e0"
import script from "./selectSizeGroup.vue?vue&type=script&lang=js"
export * from "./selectSizeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports